import { useEffect, useState } from "react";
import { getMobilePlatform } from "../utils/getMobilePlatform";
import isMobile from "is-mobile";

const DiscountBannerMobile = ({ src, roundedClass }) => {
  const [isPhone, setIsPhone] = useState(false);
  const [href, setHref] = useState("");

  const isWide = src?.includes("1350x210");
  const aspectClass = isWide ? "aspect-[1350/210]" : "aspect-[900/150]";

  useEffect(() => {
    const mobile = isMobile();

    setIsPhone(mobile);

    if (mobile) {
      setHref(
        getMobilePlatform() === "ios"
          ? "https://apps.apple.com/us/app/villavillam/id6757299847"
          : "https://play.google.com/store/apps/details?id=com.villavillam.app",
      );
    }
  }, []);

  const className = `block w-full bg-contain bg-no-repeat bg-center relative ${aspectClass} ${roundedClass} my-6`;

  const style = {
    backgroundImage: `url(${src})`,
  };

  if (!isPhone) {
    return <div className={className} style={style} />;
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={style}
    />
  );
};

export default DiscountBannerMobile;
